import { useState } from 'react';
import { CuttingModal2 } from './CuttingModal2';

/**
 * Block 14 «Раскрой» — модалка «Импорт деталей — выбор формата» (PR #4-SHELL, CUT-1.9).
 *
 * Разметка/стиль вербатим прототипа (`#import-format-modal`, `.import-format-list`
 * / `.import-fmt-btn` / `-ico` / `-info` / `-name` / `-note`, styles.css каскад).
 * **СПИСОК форматов = канон §IX.Z (7 пунктов), НЕ прототип** — устаревший v3.5-список
 * (Imos/Woody2/WoodWop/iLENIA) отброшен (решение супервайзера, handover §6.2).
 * Выбор ЛЮБОГО формата (вкл. Excel — demo-маппинг прототипа НЕ переносим) → заглушка
 * в стиле `importStubFormat` (парсеры — EP-6). Прототип alert → инлайн-панель (как
 * PR #2-UI заменил alert-навигацию на реальную).
 */

interface ImportFormat {
  id: string;
  ico: string;
  color: string;
  name: string;
  note: string;
}

/** Канон §IX.Z — 7 форматов импорта (имена вербатим handover §6.2). */
const FORMATS: ImportFormat[] = [
  {
    id: 'excel',
    ico: 'XLS',
    color: '#16a34a',
    name: 'Excel (.xls, .xlsx, .csv)',
    note: 'Excel-таблица',
  },
  {
    id: 'pro100',
    ico: 'P100',
    color: '#0ea5e9',
    name: 'Pro100 (.csv, .txt)',
    note: 'Проект Pro100',
  },
  {
    id: 'bazis-oblx',
    ico: 'OBLX',
    color: '#f59e0b',
    name: 'Базис-Мебельщик (.oblx)',
    note: 'Базис-Мебельщик',
  },
  {
    id: 'bazis-xls',
    ico: 'БМ',
    color: '#d97706',
    name: 'Базис-Мебельщик (.xls)',
    note: 'Базис-Мебельщик (Excel-выгрузка)',
  },
  {
    id: 'sketchup',
    ico: 'SKP',
    color: '#8b5cf6',
    name: 'SketchUp (CSV через CutList)',
    note: 'SketchUp + CutList',
  },
  { id: 'bcad', ico: 'BCAD', color: '#06b6d4', name: 'BCAD (.xml)', note: 'BazisCAD' },
  { id: 'giblab', ico: 'ГЛ', color: '#84cc16', name: 'ГибЛаб (.project)', note: 'ГибЛаб' },
];

export function ImportFormatDialog({ onClose }: { onClose: () => void }) {
  const [stub, setStub] = useState<ImportFormat | null>(null);

  if (stub) {
    return (
      <CuttingModal2
        title="Импорт деталей — выбор формата"
        footer={
          <button type="button" className="sc-modal-btn" onClick={onClose}>
            Закрыть
          </button>
        }
      >
        <p style={{ padding: '20px', color: 'var(--text-primary)', textAlign: 'center' }}>
          Импорт формата «{stub.name}» — парсер появится позже (в разработке).
        </p>
      </CuttingModal2>
    );
  }

  return (
    <CuttingModal2
      title="Импорт деталей — выбор формата"
      footer={
        <button type="button" className="sc-modal-btn" onClick={onClose}>
          Отмена
        </button>
      }
    >
      <div className="import-format-list">
        {FORMATS.map((f) => (
          <button key={f.id} type="button" className="import-fmt-btn" onClick={() => setStub(f)}>
            <span className="import-fmt-ico" style={{ background: f.color }}>
              {f.ico}
            </span>
            <span className="import-fmt-info">
              <span className="import-fmt-name">{f.name}</span>
              <span className="import-fmt-note">{f.note}</span>
            </span>
          </button>
        ))}
      </div>
    </CuttingModal2>
  );
}
